var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":("https://minotar.net/helm/" + _vm.id + "/" + _vm.size + ".png"),"title":_vm.title ? (_vm.name + "'s avatar") : ''}})}
var staticRenderFns = []

export { render, staticRenderFns }